import { formatInstant } from '@repo/date-time'

/**
 * Single source of truth for dealer back office timestamp display.
 *
 * Renders an instant in the policy time zone (`FIXED` / `Asia/Seoul`),
 * independent of the viewing dealer's machine timezone.
 *
 * Screens previously called `dayjs(value).format(...)` directly, which rendered
 * in the browser's local zone: the same settlement read differently for a
 * dealer abroad than for the admin back office.
 */
export function formatKstDateTime(
  value: string | number | Date | null | undefined,
  format = 'YYYY-MM-DD HH:mm',
): string {
  return formatInstant(value, { format, legacyOffsetlessAsUtc: true, fallback: '-' })
}
